import { Injectable } from '@angular/core';
import { AjaxService } from './ajax.service';
import { LocalStorageService } from './local-storage.service';
import { UserService } from './user.service';
import { AttendanceInterface } from '../interfaces/attendance.interface';
import { AttendanceHistoryResponseInterface } from '../interfaces/attendance-history-response.interface';
import { AttendanceHistoryItemInterface } from '../interfaces/attendance-history-item.interface';
import { CHANNEL } from '../constants/channel.constant';
import { ENDPOINTS } from '../constants/endpoints.constant';
import { dateFormatter } from '../utils/date-formatter.util';

@Injectable({
  providedIn: 'root'
})
export class AttendanceService {
  private attendance: AttendanceInterface;

  get attendanceId() {
    return this.attendance && this.attendance.id;
  }

  get attendanceProtocol() {
    return this.attendance && this.attendance.protocolo;
  }

  constructor(
    private ajaxService: AjaxService,
    private localStorageService: LocalStorageService,
    private userService: UserService
  ) {}

  public async startAttendance(userAccessToken: string, userId: string) {
    const attendanceFromStorage = this.localStorageService.getJson('app_attendance');

    if (!attendanceFromStorage) {
      const attendance = await this.ajaxService.post<AttendanceInterface>(
        `${ENDPOINTS.startAttendance.url}?cidadao=${userId}&canal=${CHANNEL}`,
        {},
        false,
        { Authorization_lc: `Bearer ${userAccessToken}` }
      );

      this.localStorageService.setJson('app_attendance', attendance);

      this.attendance = attendance;
    } else {
      this.attendance = attendanceFromStorage;
    }
  }

  public async endAttendance(userAccessToken: string) {
    this.localStorageService.remove('app_attendance');

    return this.ajaxService.post<void>(`${ENDPOINTS.endAttendance.url}/${this.attendance.id}`, {}, false, {
      Authorization_lc: `Bearer ${userAccessToken}`
    });
  }

  //TODO: Alterar futuramente para não pegar as infos do histórico
  public async getInfoCurrentAttendance(userAccessToken: string): Promise<AttendanceHistoryItemInterface> {
    const response = await this.getAttendanceHistory(userAccessToken, 1, this.attendanceProtocol);
    return response.historicoAtendimentos[0];
  }

  public async getAttendanceHistory(
    userAccessToken: string,
    pagina: number,
    nroProtocolo?: number,
    dtInicio?: string,
    dtFim?: string,
    situacaoAtendimento?: string
  ): Promise<AttendanceHistoryResponseInterface> {
    const userId = parseInt(this.userService.getUserId());

    const body = Object.assign(
      {},
      { nroIntCidadao: userId },
      { pagina },
      nroProtocolo && { nroProtocolo },
      dtInicio && { dtInicio },
      dtFim && { dtFim },
      situacaoAtendimento && { situacaoAtendimento }
    );

    const response = await this.ajaxService.post<AttendanceHistoryResponseInterface>(
      ENDPOINTS.getAttendanceHistory.url,
      body,
      false,
      {
        Authorization_lc: `Bearer ${userAccessToken}`
      }
    );

    if (response && response[0] && response[0].message) {
      return {
        totalDePaginas: 0,
        historicoAtendimentos: []
      };
    }

    const parsedHistoricoAtendimentos = response.historicoAtendimentos.map((item) => {
      const parsedListaSolicitacaoResponse = item.listaSolicitacaoResponse.map((subitem) => {
        return {
          ...subitem,
          dtInicio: dateFormatter(subitem.dtInicio),
          dtFim: dateFormatter(subitem.dtFim)
        };
      });

      return {
        ...item,
        dtInicio: dateFormatter(item.dtInicio),
        dtEncerramento: dateFormatter(item.dtEncerramento),
        listaSolicitacaoResponse: parsedListaSolicitacaoResponse
      };
    });

    return {
      totalDePaginas: response.totalDePaginas,
      historicoAtendimentos: parsedHistoricoAtendimentos
    };
  }
}
